var bighouse = bighouse || {};

bighouse.search = (function () {

    function init(){
        $(".js-filterStickyBtn").sticky({
            topSpacing: 10,
            wrapperClassName: 'SearchResults-stickyBtn'
        });


        let width = $('.SearchResults-stickyBtn').width();
        $('.SearchResults-stickyBtn').css('width', width + 'px'); //on resize it changes to zero so hardcode
    }

    function resizeStickyFilter(){
        $(".js-filterStickyBtn").sticky('update');
    }


    return {
        init: init,
        resizeStickyFilter: resizeStickyFilter
    };
})();